import { ChevronDownIcon } from '@chakra-ui/icons';

import {
  Button,
  VStack,
  StackDivider,
  ButtonGroup,
  Box,
  Flex,
  ChakraProvider,
  theme,
  List,
  ListItem,
  Link,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Stack,
  Heading,
  Text,
  Select,
  FormControl,
  SimpleGrid,
  icon,
  Spacer,
  HStack,
  Center,
} from '@chakra-ui/react';

import { auth, db } from "../firebase-config";
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { useState, useEffect } from 'react';
import firebase from 'firebase/app';
import 'firebase/firestore';
import { getDocs, orderBy } from 'firebase/firestore'; 
import { collection, addDoc, query } from "firebase/firestore";
import alumni from '../assets/alumniTwoJPG.jpg';
import alumniDoor from '../assets/alumniDoor.jpg';
import NightEBI from '../assets/nightEBI.jpg';
import Buttrick from '../assets/buttrickHall.jpg';


// Department list component
export default function Departments() {
  const [courses, setCourses] = useState([]);
  document.body.style.background = 'lightyellow';
  //document.body.style.background = `url(${Kirkland}) center center / cover fixed no-repeat, rgba(255, 255, 153, 0.5)`;
  //background: url('../assets/Kirkland_Image.png') center center fixed no-repeat;

  useEffect(() => {
    const searchQuery = async () => {
      const query1 = query(collection(db, "departments"), orderBy("deptName"));
      const q = await getDocs(query1);
      const promises = q.docs.map(async (doc) => {
        const c = query(collection(db, `departments/${doc.id}/courses`));
        const querySnapshot2 = await getDocs(c);
        const counter = querySnapshot2.size.toString();
        const temp = await Promise.all([doc.data()["deptName"], [doc.data()["deptCode"]], counter]);
        return temp;
      });
      const allInfoArr = await Promise.all(promises);
      const sortedCourses = [...allInfoArr].sort((a, b) => b[2] - a[2]);
      setCourses(sortedCourses);
    };
    searchQuery();
  }, []);

  const A_to_Z_searchQuery = async () => {
    const query1 = query(collection(db,"departments"), orderBy("deptName"));
    const q = await getDocs(query1);
      const promises = q.docs.map(async (doc) => {
        const c = query(collection(db, `departments/${doc.id}/courses`));
        const querySnapshot2 = await getDocs(c);
        const counter = querySnapshot2.size.toString();
        const temp = await Promise.all([doc.data()["deptName"], [doc.data()["deptCode"]], counter]);
        return temp;
      });
      const allInfoArr = await Promise.all(promises);
      setCourses(allInfoArr);
  };

  const Z_to_A_searchQuery = async () => {
    const query1 = query(collection(db,"departments"), orderBy("deptName","desc"));
    const q = await getDocs(query1);
      const promises = q.docs.map(async (doc) => {
        const c = query(collection(db, `departments/${doc.id}/courses`));
        const querySnapshot2 = await getDocs(c);
        const counter = querySnapshot2.size.toString();
        const temp = await Promise.all([doc.data()["deptName"], [doc.data()["deptCode"]], counter]);
        return temp;
      });
      const allInfoArr = await Promise.all(promises);
      setCourses(allInfoArr);
  };

  const num_Courses_ReviewedQuery = async () => {
    const sortedCourses = [...courses].sort((a, b) => b[2] - a[2]);
    setCourses(sortedCourses);
  };

  function getReviewString(inputString) {
    let returnString;
    if (inputString === "1") {
      returnString = "1 review";
    } else {
      returnString = `${inputString} reviews`;
    }
    return returnString;
  }
  

  return (
    <ChakraProvider theme={theme}>
      <div style={{ 
        background: `url(${NightEBI}) center center fixed no-repeat`,
        backgroundSize: "cover",
        height: "650vh",
        width: "100vw",
        position: "relative"
      }}>
        <div style={{ 
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(255, 255, 224, 0.1)"
        }}>
        <VStack>
      
        <Box width="10px" />
        <HStack alignSelf={'end'}>
          <FormControl style={{backgroundColor: 'rgba(200, 200, 200, 0.9)'}}>
            
            <Select 
            icon={<ChevronDownIcon />} 
            
            placeholder='Sort By' 
            
            // width= "110px"
            onChange={(val) => {
              if (val.target.value === 'option1') {
                A_to_Z_searchQuery();
              } else if (val.target.value === 'option2') {
                Z_to_A_searchQuery();
              } else {
                num_Courses_ReviewedQuery();
              }
            }
            }>
              <option value='option1'>A-Z</option>
              <option value='option2'>Z-A</option>
              <option value='option3'># of courses reviewed</option>
            </Select>
            
          </FormControl>
          <Box width="10x" />
        </HStack>
        <Box textAlign="center">
        
          <Heading size="lg" mb={4}>
          <div style={{ 
            fontFamily: 'Helvetica Neue',
            WebkitTextFillColor: 'black', // for Safari
            textFillColor: 'black',
            
            }}>
            All Departments: 
            </div>
          </Heading>
        
        </Box>
        <Box height="auto" overflowY="scroll">
        <SimpleGrid spacing={3} columns={2}>
        {courses.map((item) => (
          <div style={{ flex: 1 }} key={item[1]}>
            <Card style={{backgroundColor: '#ffd966'}} variant={'filled'}>
              <CardBody>
                <Stack spacing='3'>
                  <Link href={`/departments/${item[1]}`}>
                    <Heading size='md' color='black'>{item[0]}</Heading>
                  </Link>
                  <Text>{getReviewString(item[2])}</Text>
                </Stack>
              </CardBody>
            </Card>
          </div>
        ))}
        </SimpleGrid>
        </Box>
      </VStack>
     
      </div>
     </div> 
    </ChakraProvider>
  );
}
